export default __webpack_public_path__ + "static/media/leafplayer-logo.51b1b80a.svg";